
import { Injectable } from "@angular/core";


@Injectable( {
	providedIn: "root"
} )


export class FinancialService {

	constructor(
	) { }

	public getVolumePricesFromProducts( products ): number{
		return products.reduce( ( accumulator, current ) => accumulator + current.price * current.volume, 0 );
	}
}
